import { createContext } from 'react';

export interface AdminIdentity {
  id: number;
  email: string;
}

export interface AuthContextValue {
  /** `null` = não autenticado; `undefined` enquanto a sessão é conferida. */
  admin: AdminIdentity | null | undefined;
  scopes: string[];
  isChecking: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  /** Marca a sessão como perdida (usado quando o proxy devolve 401). */
  clearSession: () => void;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
